$(document).ready(function() {
    if ($('.select-single').length) {
        $('.select-single').select2();  
    }
    if ($(".select-tags").length) {
        $(".select-tags").select2({
            tags: true
        });
    }
    if ($('.select-register').length) {
        $(".select-register").select2({
            minimumInputLength: 3
        });
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/select2.js